import { create } from "zustand";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import { apiCall } from "../../../../utils/apiCall";

const useHygieneStore = create((set, get) => ({
    hygieneObservations: [],
    loading: false,
    error: false,
    statusFilter: "",

    fetchHygieneObservations: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();
        try {
            const hygieneData = await apiCall({
                url: `${API_BASE_URL1}IEMasterDetails/GetHygieneObservations?${queryString}`,
                method: "get",
                token: localStorage.getItem("token"),
            });

            set({
                hygieneObservations: Array.isArray(hygieneData) ? hygieneData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");

            if (error.response && error.response.status === 404) {
                set({
                    hygieneObservations: [],
                    error: "No hygiene observations found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        } finally {
            set({ loading: false });
        }
    },

    // Create a New Hygiene Observation with Validation Handling
    addHygieneObservation: async (newObservation) => {
        set({  error: null });

        try {
            const response = await apiCall({
                url: `${API_BASE_URL1}IEMasterCreate/AddNewHygieneOberservation`,
                method: "post",
                token: localStorage.getItem("token"),
                data: newObservation,
            });

            set((state) => ({
                hygieneObservations: [...state.hygieneObservations, response],
                loading: false
            }));

            toast.success("Hygiene observation added successfully!"); // ✅ Success toast
            return { success: true };

        } catch (error) {
            console.error("Error adding observation:", error.response?.data || error.message);

            if (error.response?.status === 400) { // Handle validation errors
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // Handle general errors
            const errorMessage = error.response?.data || "Failed to add observation";
            toast.error(errorMessage);
            set({ error: errorMessage, loading: false });

            return { success: false, errors: { general: errorMessage } };
        }
        finally {
            set({ loading: false });
        }
    },


    // Update a existing Hygiene Observation with Validation Handling
    updateHygieneObservation: async (updateObservation) => {
        set({  error: null });

        try {
            const response = await apiCall({
                url: `${API_BASE_URL1}IEMasterCreate/UpdateHygieneObservation`,
                method: "put",
                token: localStorage.getItem("token"),
                data: updateObservation,
            });

            set((state) => ({
                hygieneObservations: [...state.hygieneObservations, response],
                // loading: false
            }));


            toast.success("Hygiene observation Updated successfully!");
            return { success: true };

        } catch (error) {
            console.error("Error adding observation:", error.response?.data || error.message);

            if (error.response?.status === 400) { 
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // Handle general errors
            const errorMessage = error.response?.data || "Failed to add observation";
            toast.error(errorMessage);
            set({ error: errorMessage, loading: false });

            return { success: false, errors: { general: errorMessage } };
        }
        finally {
            set({ loading: false });
        }
    },
}));

export default useHygieneStore;
